import { FC } from "react"
import InlineOverlay from "./overlays/InlineOverlay"
import ModalOverlayComp from "./overlays/ModalOverlay"
import SlideOverlay from "./overlays/SlideOverlay"
import { OpenCloseRender, OverlayProps } from "./types"
export type { OpenCloseRender }

export type OverlayType = "modal" | "slide" | "inline"
export const ModalOverlay: FC<OverlayProps & { overlayType?: OverlayType; includeX?: boolean }> = (
  props
) => {
  const { overlayType, ...restOfProps } = props
  switch (overlayType) {
    case "slide":
      return <SlideOverlay {...restOfProps} />
    case "inline":
      return <InlineOverlay {...restOfProps} />
    default:
      return <ModalOverlayComp {...restOfProps} />
  }
}
export default ModalOverlay
